import { Dropdown } from "primereact/dropdown";
import { Slider } from "primereact/slider";
import React, { useEffect, useState } from "react";
import { getProvince } from "../../../StateManagement/ProvinceSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../../Cpanel/Components/Utilities";
import { set } from "date-fns";
import { classNames } from "primereact/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const FilterSidebar = ({
  activeTab,
  shopList,
  className,
  onCloseFilterMobile,
}) => {
  const [value, setValue] = useState([20, 80]);
  // const [provinceList, setProvinceList] = useState(0);
  const [provinceId, setProvinceId] = useState(0);
  const [provinceList, setProvinceList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [cityId, setCityId] = useState(0);
  const [sliderValue, setSliderValue] = useState([20, 80]);
  const [inputValue, setInputValue] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [filterChanged, setFilterChanged] = useState(false);
  const province = useSelector((state) => state?.province?.province);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProvince());
    const proviceOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.provinceid,
        label: item.provincename,
      }));
    };
    const provinceData = proviceOptions(province);
    setProvinceList(provinceData);

    fetchData("catlist", {}, handleCatResponse);
  }, []);
  const handleCatResponse = (data) => {
    const mapCats = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.catid.toString(),
        label: item.name,
      }));
    };
    setCategoryList(mapCats(data?.dt));
  };
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("provinceId", selectedProvince);
    fetchData("city", bodyFormData, handleCityApiResponse);
  }, [selectedProvince]);
  const handleCityApiResponse = (data) => {
    const cityOptions = (apiResponse) => {
      return apiResponse?.dt?.map((item) => ({
        value: item.cityid,
        label: item.cityname,
      }));
    };
    const cityData = cityOptions(data);
    setCityList(cityData);
  };
  // Function to handle slider value change
  const handleSliderChange = (event) => {
    const value = event?.value;
    // setSliderValue(value);
  };

  // Function to handle dropdown selection change
  const handleDropdownChange = (event, type) => {
    const value = event?.target?.value;
    console.log(value, event.value);
    if (type === "province") {
      setSelectedProvince(value);
    } else if (type === "city") {
      setSelectedCity(value);
    } else if (type === "category") {
      setSelectedCategory(value);
    } else if (type === "cashback") {
      setSliderValue(event?.value);
    }
    setFilterChanged(true);
  };
  useEffect(() => {
    const fetchDataTimeout = setTimeout(() => {
      filterShops({
        sliderMinValue: sliderValue[0],
        sliderMaxValue: sliderValue[1],
        inputValue,
        selectedProvince,
        selectedCity,
        selectedCategory,
      });
    }, 1000);

    return () => {
      clearTimeout(fetchDataTimeout);
    };
  }, [sliderValue, selectedCategory, selectedCity, selectedProvince]);

  // Function to filter shops based on the current filters
  const filterShops = (filterParams) => {
    console.log(activeTab);
    // Make API call to fetch filtered shop list
    // Replace this with your actual API call logic
    const filteredShops = []; // Your filtered shop list
    // onChange(filteredShops); // Call the onChange function with filtered shop list
    const bodyFormData = new FormData();
    bodyFormData.append("type", activeTab==="online"? 1: 2);
    bodyFormData.append("filterparams", JSON.stringify(filterParams));
    fetchData("shoplist", bodyFormData, handleFilterResponse);
  };
  const handleFilterResponse = (response) => {
    // console.log(response);
  };
  const handleDeleteFilter = () => {
    setSelectedCategory("");
    setSelectedCity("");
    setSelectedProvince("");
    setSliderValue([20, 80]);
    setFilterChanged(false);
  };
  return (
    <div className={`${className} bg-white`}>
      <div
        className={
          className === "filter-sidebar open"
            ? "d-flex justify-content-end "
            : "d-none"
        }
        onClick={onCloseFilterMobile}
      >
        <FontAwesomeIcon
          icon={"close"}
          className="text-danger bg-light rounded p-2 fs-6 fs-bold mx-3"
        />
      </div>
      <div>
        <div className="d-flex flex-direction-row justify-content-between align-items-center px-3 ">
          <h4 className="p-3">فیلترها</h4>
          {filterChanged && (
            <div className="text-danger fs-6" onClick={handleDeleteFilter}>
              حذف فیلترها
            </div>
          )}
        </div>
        <div className="px-3 ">

          <div className="card flex justify-content-center py-1">
          <div>محدوده کش بک</div>
            <div className="d-flex align-items-center justify-content-between p-2 ">
              <div>%{sliderValue[1]}</div>
              <div>%{sliderValue[0]}</div>
            </div>
            <Slider
              value={sliderValue}
              name="cashback"
              onChange={(e) => handleDropdownChange(e, "cashback")}
              className="w-14rem"
              range
            />
            <div className="d-flex align-items-center justify-content-between p-1 ">
              <div className=" text-color-light">بیش ترین</div>
              <div className=" text-color-light">کمترین</div>
            </div>
          </div>
        </div>
        <div className="card px-3 py-1">
          <div className="pb-3"> موقعیت مکانی</div>
          <div className="mb-3">
            <Dropdown
              value={selectedProvince}
              options={provinceList}
              onChange={(e) => {
                handleDropdownChange(e, "province");
              }}
              optionValue="value"
              optionLabel="label"
              placeholder={"استان"}
              name={"province"}
              className="w-75"
              filter
            />
          </div>
          <div className="pt-2">
            <Dropdown
              value={selectedCity}
              options={cityList}
              onChange={(e) => {
                handleDropdownChange(e, "city");
              }}
              optionValue="value"
              optionLabel="label"
              placeholder={"شهر"}
              name={"province"}
              className="w-75"
              filter
            />
          </div>
        </div>
        {/* <div className="px-3 pt-4 ">
          <div>دسته بندی فروشگاه ها</div>
          <div className="pt-2">
            <Dropdown
              value={selectedCategory}
              options={categoryList}
              onChange={(e) => {
                handleDropdownChange(e, "category");
              }}
              optionValue="value"
              optionLabel="label"
              placeholder={"دسته بندی"}
              name={"province"}
              className="w-75"
              filter
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};

{
  /* <div className="d-flex justify-content-between align-items-center pb-3">
            <span className="">از</span>
            <input className=" filter-input border-none" ></input>
            <span>%</span>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span>تا</span>
            <input className=" filter-input border-none" ></input>
            <span>%</span>
          </div> */
}
